module.exports = __webpack_public_path__ + "static/media/arts_24.348ac00d.jpg";